import React from 'react'
import './style.scss'
import moment from 'moment';
import 'moment/locale/sv';
import apiHelper from '../../util/api.helper.js';

class NewsPresentation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { entry } = this.props

        let formattedCreated = entry.PublishedAt ? moment(entry?.PublishedAt).format('YYYY-MM-DD') : null

        return (
            <article>
                <h1>{entry?.Title}</h1>
                <time dateTime={formattedCreated}>{formattedCreated}</time>
                <div dangerouslySetInnerHTML={{ __html: entry?.NewsContent }} />
                <footer>
                    {
                        entry?.Attachment && <a onClick={() => { apiHelper.getFile(this.props.header, 'News/GetAttachment', entry.Attachment, entry.Attachment.Title); } } className="file">{entry.Attachment.Title}</a>
                    }
                </footer>
            </article>
            )
        }
    }
    
    export default NewsPresentation;
